export default {
    LOGIN_SUCCESS: (state, { token, userId, userName, userEmail, firstName, lastName }) => {
        state.token = token
        state.userId = userId
        state.userName = userName
        state.userFirstName = firstName
        state.userLastName = lastName
        state.userEmail = userEmail
    },
    REFRESH_TOKEN_SUCCESS: (state, token) => {
        state.token = token
    },
    LOGOUT_SUCCESS: state => {
        state.token = null
        state.userId = null
        state.userName = null
        state.userFirstName = null
        state.userLastName = null
        state.userEmail = null
        state.user = null
        state.receivedPermissions = false
        state.permissions = []
    },
    GET_USER: (state, user) => {
        state.user = user
    },
    GET_USER_PERMISSIONS_SUCCESS: (state, data) => {
        state.receivedPermissions = true
        state.permissions = data
    }
}
